import { Component, Input } from '@angular/core'
import * as JsDiff from 'diff'

@Component({
  selector: 'app-diff',
  templateUrl: './diff.component.html',
  styleUrls: ['./diff.component.scss'],
  standalone: false
})
export class DiffComponent {
  @Input() left = ''
  @Input() right = ''
  @Input() resultid = 'result'

  @Input() leftHeader = ''
  @Input() rightHeader = ''
  @Input() compareHeader = ''
  @Input() hasHeader = false

  compare(left: string = null, right: string = null): number {
    this.left = left || this.left
    this.right = right || this.right

    let differences = 0
    const diff = JsDiff.diffChars(this.left, this.right)
    const display = document.getElementById(this.resultid)
    const fragment = document.createDocumentFragment()

    display.innerHTML = ''
    let index = 0
    diff.forEach((part, i) => {
      const color = part.added ? 'blue' : part.removed ? 'red' : 'grey'
      const differs = !!(part.added || part.removed)
      const span = document.createElement('span')
      if (differs) {
        index++
        span.id = `${this.resultid}-${index}`
        differences++
      }
      span.style.color = color
      span.appendChild(document.createTextNode(part.value))
      fragment.appendChild(span)
    })
    display.appendChild(fragment)

    return differences
  }
}
